import { render, staticRenderFns } from "./addmap.vue?vue&type=template&id=8a6e1e7a"
import script from "./addmap.vue?vue&type=script&lang=js"
export * from "./addmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports